package link.erpango.quip

import link.erpango.quip.core.SharedFactory
import link.erpango.quip.data.DataSource
import link.erpango.quip.data.JsSessionStorage
import link.erpango.quip.data.db.DbDriverFactory
import link.erpango.quip.data.firebase.JsFirebaseClient
import link.erpango.quip.utils.JsFileUtils
import link.erpango.quip.utils.JsPlatformManager
import link.erpango.quip.utils.DatetimeUtils

class AppSharedFactory {

    suspend fun create(): SharedFactory {
        val dataSource = DataSource(
            _apiUrl = WebConfig.API_URL,
            _firebase = JsFirebaseClient(),
            _sqlDriver = DbDriverFactory().createDriverJs(),
            _appVersion = "1.0.0" // TODO: Get real version if possible
        )
        dataSource.init()

        // Restore session from localStorage into the in-memory DB
        val savedSession = JsSessionStorage.getSession()
        if (savedSession != null) {
            try {
                dataSource.db.auth.insertToken(
                    userId = savedSession.user ?: "",
                    accessToken = savedSession.access ?: "",
                    refreshToken = savedSession.refresh ?: "",
                    createdAt = savedSession.createdAt ?: DatetimeUtils.currentTimeMillis()
                )
                println("AppSharedFactory: Restored session from localStorage")
            } catch (e: Exception) {
                println("AppSharedFactory: Failed to restore session: ${e.message}")
                JsSessionStorage.clearSession()
            }
        }

        return SharedFactory(
            dataSource = dataSource,
            platformManager = JsPlatformManager(),
            fileUtils = JsFileUtils()
        )
    }
}
